<template lang="pug">
    ApolloQuery(:query="require('../graphql/JobIndex.gql')",:variables="{ locale }")
        template(slot-scope="{ result: { data }, isLoading }")
            Loading(v-if="isLoading" :active="isLoading")
            page-not-found(v-else-if="!(data && data.job_index && data.jobs)")
            .jobs(v-else)
                MetaTags(v-bind="data.job_index.meta_tags")
                LayoutBannerBreadCrumb(:locale='locale',  :cover='data.job_index.cover', :name='data.job_index.title')
                .container.container-jobs
                    .row
                        .col-12
                            .leadin
                                h3(align='left') {{ data.job_index.header }}
                                p(align='left')  {{ data.job_index.subtitle }}
                    .col-12
                        .search-bar
                            .search-bar__container.container
                                .row.container-jobs
                                    .col-12.col-md-6
                                        input.button-rounded(v-model='keyword', :placeholder='data.job_index.search_keyword', v-on:input="filter()")
                                        .keyword__clear(@click="clearKeyword")
                                            img(src="@/assets/jobs/times-solid.svg")
                                    .col-12.col-md-6
                                        v-select(v-model='category',
                                            :options="morphCategories(data.job_categories)",
                                            :placeholder="data.job_index.search_category",
                                            v-on:input="filter()")
                    JobList(v-bind='search', :jobs='data.jobs', :btn_others='data.job_index.btn_others', :locale="locale")
                    .row
                        .col-12
                            .applyInfo
                                .applyInfo__title
                                    h3 {{ data.job_index.apls_header }}
                                .applyInfo__leadin(v-html="data.job_index.apls_body")
                                .applyInfo__methods
                                    .applyInfo__method
                                        .applyInfo__icon
                                            img(v-bind='data.job_index.apls_left_icon')
                                        .applyInfo__text(v-html='data.job_index.apls_left_content')
                                    .applyInfo__method
                                        .applyInfo__icon
                                            img(v-bind='data.job_index.apls_center_icon')
                                        .applyInfo__text(v-html='data.job_index.apls_center_content')
                                    .applyInfo__method
                                        .applyInfo__icon
                                            img(v-bind='data.job_index.apls_right_icon')
                                        .applyInfo__text(v-html='data.job_index.apls_right_content')
                                .applyInfo__footer(v-html='replaceUrl(data.job_index.privacy_remarks)')
                                .applyInfo__remark(v-html='data.job_index.privacy_remarks_subtitle')
                WidgetHowToJoin(v-if='data.job_index.page_bottom', v-bind='data.job_index.page_bottom')
</template>

<script>
    import LayoutBannerBreadCrumb from "../components/LayoutBannerBreadCrumb.vue";
    import WidgetHowToJoin from "../components/WidgetHowToJoin.vue";
    import JobList from "../components/JobList";
    import Loading from "../components/Loading.vue";
    import vSelect from 'vue-select';
    import 'vue-select/dist/vue-select.css';
    import PageNotFound from './PageNotFound';
    import MetaTags from '../components/MetaTags';

    export default {
        name: "Jobs",
        props: {
            locale: String
        },
        data() {
            return {
                keyword: '',
                category: '',
                search: {
                    keyword: '',
                    category: ''
                }
            };
        },
        components: {
            MetaTags,
            PageNotFound,
            LayoutBannerBreadCrumb,
            WidgetHowToJoin,
            JobList,
            vSelect,
            Loading
        },
        methods: {
            replaceUrl(html) {
                return html.replace(/(<a href=".+")/, '$1 target="_blank"');
            },
            filter() {
                this.search = {
                    keyword: this.keyword,
                    category: this.category
                }
            },
            morphCategories(categories) {
              const REGEX_CHINESE = /[\u4e00-\u9fff]|[\u3400-\u4dbf]|[\u{20000}-\u{2a6df}]|[\u{2a700}-\u{2b73f}]|[\u{2b740}-\u{2b81f}]|[\u{2b820}-\u{2ceaf}]|[\uf900-\ufaff]|[\u3300-\u33ff]|[\ufe30-\ufe4f]|[\uf900-\ufaff]|[\u{2f800}-\u{2fa1f}]/u;
              const morphed = categories.map(v => v.name).filter(v => v !== null).reduce((obj, category) => {
                const locale = REGEX_CHINESE.test(category) ? 'zh' : 'en';
                return {
                  ...obj,
                  [locale]: [...obj[locale], category],
                }
              }, {en: [], zh: []});
              morphed.en = morphed.en.sort();
              morphed.zh = morphed.zh.sort((a, b) => a.localeCompare(b));
              return this.locale === 'en' ? [ ...morphed.en, ...morphed.zh ] : [ ...morphed.zh, ...morphed.en ];
            },
            clearKeyword() {
              this.keyword = '';
              this.filter();
            }
        },
    };
</script>

<style lang="sass">
    .vs__dropdown-toggle
        border-radius: 2rem
        background: white
        border: none
        width: 100%
        padding: 1rem 2rem
        line-height: 2rem
        font-size: 1.5rem
        @media (max-width: 1023.98px)
            width: 90%
            padding: .5rem 1rem
            margin-bottom: .5rem
            margin-left: auto
            margin-right: auto
            font-size: 1.125rem
    .vs--open .vs__dropdown-toggle
        // border-radius: 2rem
    .vs__search,
    .vs__searchL:focus
        font-size: 1.5rem
        color: #828282
        @media (max-width: 1023.98px)
            padding-top: 0
            padding-bottom: 0
            padding-left: 0
            margin-top: 0
            font-size: 1.125rem
    .vs__selected
        max-width: 90%
        height: 2rem
        display: block
        overflow: hidden
        text-overflow: ellipsis
        white-space: nowrap
        &-options
            max-width: 90%

</style>
<style lang="sass" scoped>
@import "../../node_modules/bootstrap/scss/functions"
@import "../assets/styles/CustomVariables"
@import "../assets/styles/wysiwyg"
@import "../assets/styles/common"
@import "../../node_modules/bootstrap/scss/variables"
@import "../../node_modules/bootstrap/scss/mixins"
@import "../../node_modules/bootstrap/scss/grid"
.container-jobs
    @media (min-width: 1600px)
        padding: 0 11rem
    h3
        font-size: 2rem
        @include media-breakpoint-down(lg)
            font-size: 1.5rem
    p
        font-size: 1.5rem
        font-weight: bold
        color: #8c8c8c
        @include media-breakpoint-down(md)
            font-size: 1.3rem
        @include media-breakpoint-down(sm)
            font-size: 1rem
.search-bar
    background: #ebebeb
    width: 100vw
    position: relative
    left: 50%
    right: 50%
    margin-left: -50vw
    margin-right: -50vw
    &__container
        padding: 1.5rem 0
        @include media-breakpoint-down(md)
            text-align: center
        input
            width: 100%
            border: none
            font-size: 1.5rem
            @include media-breakpoint-down(md)
                width: 90%
                padding: .5rem 1rem
                margin-bottom: .5rem
                font-size: 1.125rem
            &:focus
                outline: none
        a,
        a:link,
        a:visited
            width: 100%
            color: white
            cursor: pointer
            @include media-breakpoint-down(md)
                width: 90%
                padding: .5rem 1rem
                font-size: 1.125rem

.applyInfo
    background: #e9fbff
    font-size: 1.25rem
    margin-top: 5rem
    padding: 3rem 3rem
    @include media-breakpoint-down(md)
        padding: 1rem
        margin-top: 2rem

    &__leadin,
    &__footer
        @include media-breakpoint-down(md)
            font-size: 1rem

    &__title
        color: #858180
        h3
            margin-bottom: 0

    &__methods
        display: -webkit-flex
        -webkit-justify-content: center
        display: flex
        justify-content: space-around
        padding: 1.5rem 0
        @include media-breakpoint-down(md)
            flex-wrap: wrap

    &__method
        display: inline-block
        div
            display: inline-block
            vertical-align: top
        @include media-breakpoint-down(md)
            position: relative
            width: 100%
            padding-left: 4rem
            padding-bottom: 1rem
    &__icon
        padding: 0 .5em
        @include media-breakpoint-down(md)
            position: absolute
            left: 0
            top: 0
            width: 3rem
            padding: 0
            transform: scale(.8)
            transform-origin: 50% 0
            text-align: center
        img
            @include media-breakpoint-down(md)
                height: 2rem

    &__remark
        font-size: 1rem
            color: #69686e

.keyword__clear
    cursor: pointer
    position: absolute
    right: 2rem
    padding: 1.5rem 1.5rem
    top: -.1rem
    @include media-breakpoint-down(md)
        padding-top: 0.7rem
    @include media-breakpoint-down(sm)
        right: 2.5rem
    img
        height: 1rem
</style>

<style lang="sass">
    .applyInfo
        a
            color: #00d8be
        &__text p
            margin-bottom: 0
            @media (max-width: 1023.98px)
                font-size: 1rem
</style>
